<template>
	<section class="p-5 space-y-6 rounded-lg bg-grey-950">
		<OverviewSummary :summary="summary" embedded />

		<OverviewProfileHighlights
			:job-offer-data="jobOfferData"
			:applicant-data="applicantData"
			:wheel-mode="wheelMode"
			embedded
			stacked
		/>
	</section>
</template>

<script>
import OverviewProfileHighlights from './OverviewProfileHighlights.vue'
import OverviewSummary from './OverviewSummary.vue'

export default {
	name: 'OverviewProfileSummaryCard',
	components: {
		OverviewProfileHighlights,
		OverviewSummary
	},
	props: {
		summary: {
			type: Object,
			default: () => ({})
		},
		jobOfferData: {
			type: Object,
			default: () => ({})
		},
		applicantData: {
			type: Object,
			default: () => ({})
		},
		wheelMode: {
			type: String,
			required: true,
			validator: value => ['applicant', 'job'].includes(value)
		}
	}
}
</script>
